import type { FaireProductEntity } from "../../entity_types/product";

export const p_pvhwakvxms: FaireProductEntity = {
  token: "p_pvhwakvxms",
  type: "product",
  name: "Natural Palo Santo Wood Healing Energy",
  brandToken: "b_edj9u7j4sq",
  brandName: "KayleeNYC",
  imageUrl:
    "https://cdn.faire.com/fastly/824236402322b9076df3cb8980fe9584c7aed1ac1124ddeb295509a85d899fa6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f846c88b7cab1a854dfcf1b4effa636241fc32cc3fea3d2975627fe113203e07.png",
    "https://cdn.faire.com/fastly/2f1e1a1a8903566aed8be72831257b360de9b0c0719da4d8b905fb9d3bbe27fd.png",
    "https://cdn.faire.com/fastly/7909936aad192690a072d1ece7be2d0b00997949c0ad569340031ee8bd234fe4.png",
    "https://cdn.faire.com/fastly/8826bf2bfc061f5bd328d49986bd03eb7ed8ffa30fc008936a8e91b6f0846859.jpeg",
  ],
  priceDollars: 8.66,
  description:
    "Natural Palo Santo Wood, Net weight 80 grams Palo Santo per pack. Palo Santo is found in Peru. Minimum order 8 packs. Condition is New.  Free local pickup in Brooklyn, New York. Stones, crystals, crystal bulk, crystal wholesale, spiritual, meditation, metaphysical wholesale. ",
  tags: [],
  msrpDollars: 17.32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:32.062Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
